var escape = require("../css-loader/lib/url/escape.js");
exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: 'Open Sans';\r\n  src: local('Open Sans Bold'),\r\n         local('OpenSans-Bold'),\r\n         url(" + escape(require("./fonts/opensansbold.woff2")) + ") format('woff2'),\r\n         url(" + escape(require("./fonts/opensansbold.woff")) + ") format('woff'),\r\n         url(" + escape(require("./fonts/opensansbold.ttf")) + ") format('truetype');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n", ""]);

// exports
